import { BookingFilterConfig, FilterNameEnum, FilterTypeEnum } from '@shared/booking-feature';

export const bookingFiltersConfig: BookingFilterConfig = {
    fields: [
        {
            field: FilterNameEnum.SERVICE,
            required: false,
            disabled: false,
            isActive: true,
            order: 1,
            type: FilterTypeEnum.SELECT,
            placeholder: $localize`Filter service`,
            icon: 'la-stethoscope',
            undefinedText: '',
        },
        {
            field: FilterNameEnum.DATE_RANGE,
            required: false,
            disabled: false,
            isActive: true,
            order: 2,
            type: FilterTypeEnum.DATE_RANGE,
            placeholder: $localize`Preferred date range`,
            icon: 'la-calendar-week',
            undefinedText: '',
        },
    ],
};
